var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 45.0001C82.5 65.7133 65.7132 82.5001 45 82.5001C24.2868 82.5001 7.5 65.7133 7.5 45.0001C7.5 24.287 24.2868 7.50012 45 7.50012C65.7132 7.50012 82.5 24.287 82.5 45.0001Z",
    fill: "url(#paint0_radial_646_34197)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5703 33.4916C39.5703 52.5931 53.8586 68.3416 72.322 70.6779C73.2197 69.7261 74.0634 68.7418 74.853 67.7035C79.4499 61.4841 82.1648 53.7937 82.1648 45.4652C82.1648 26.3421 67.8332 10.5611 49.3266 8.26807C43.2587 14.9309 39.5703 23.7894 39.5703 33.5024V33.4916Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6618 7.80286C43.5939 14.4657 39.9055 23.3242 39.9055 33.0372C39.9055 52.1604 54.2371 67.9413 72.7437 70.2344C78.8116 63.5715 82.5 54.7238 82.5 45C82.5 25.8768 68.1684 10.0959 49.6618 7.80286Z",
    fill: "url(#paint1_radial_646_34197)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7922 51.6309C22.3183 51.3173 24.8385 47.3152 24.4166 42.7075C24.0056 38.089 20.8148 34.6061 17.2887 34.9306C13.7626 35.2443 11.2424 39.2463 11.6643 43.854C12.0753 48.4726 15.2661 51.9554 18.7922 51.6309Z",
    fill: "#B0B1B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7418 54.9841C13.6218 56.0981 13.0918 59.2348 14.552 61.993C16.0014 64.762 18.8893 66.0924 20.9985 64.9891C23.1077 63.8858 23.6377 60.7383 22.1883 57.9802C20.7389 55.222 17.8509 53.87 15.7418 54.9841Z",
    fill: "#B0B1B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.103 51.6525C22.8591 52.3123 22.5346 54.1618 23.3999 55.7951C24.2544 57.4284 25.9634 58.2179 27.2073 57.569C28.4511 56.92 28.7648 55.0596 27.9103 53.4263C27.0558 51.7931 25.3469 51.0035 24.103 51.6525Z",
    fill: "#B0B1B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6337 46.3524C78.9847 41.7663 75.6209 38.4457 72.1164 38.9433C68.6119 39.4408 66.2972 43.5618 66.9462 48.1479C67.5952 52.734 70.959 56.0546 74.4635 55.5571C77.968 55.0595 80.2827 50.9385 79.6337 46.3632V46.3524Z",
    fill: "#5D5E61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0042 35.4388C77.0593 34.2274 77.427 31.0582 75.8371 28.3758C74.2471 25.6933 71.2942 24.4927 69.2499 25.715C67.2057 26.9264 66.8271 30.0956 68.4171 32.778C70.0071 35.4712 72.9599 36.661 75.0042 35.4496V35.4388Z",
    fill: "#5D5E61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3034 35.0169C66.3624 33.4269 64.621 32.7238 63.4096 33.4377C62.1981 34.1516 61.9818 36.0228 62.912 37.6128C63.853 39.2028 65.5944 39.9058 66.8059 39.1919C68.0173 38.4781 68.2444 36.6069 67.3034 35.0169Z",
    fill: "#5D5E61"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.3971 41.4631C45.5407 30.8091 44.8052 18.4569 37.7422 13.8816C30.6792 9.29549 19.9711 14.2169 13.8274 24.8709C7.68379 35.5249 8.43012 47.8771 15.4823 52.4524C22.5562 57.0385 33.2535 52.1171 39.3971 41.4631Z",
    fill: "url(#paint2_radial_646_34197)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M78.0543 60.6946C78.1841 56.3572 71.5429 55.9354 63.2144 59.7427C54.8858 63.5501 48.0391 70.148 47.9093 74.4853C47.7795 78.8118 54.4207 79.2445 62.7493 75.4371C71.067 71.6298 77.9245 65.0211 78.0543 60.6946Z",
    fill: "url(#paint3_radial_646_34197)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_646_34197",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4227 21.4856) scale(71.1819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F1EDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA1A6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_646_34197",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.0536 -1.80199) scale(63.1886 63.1886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ADAAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6D70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_646_34197",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-238.531 -142.729) rotate(32.99) scale(15.2817 22.2279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_646_34197",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1122.6 621.472) rotate(-24.58) scale(16.5957 7.00937)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherMoon);
export default __webpack_public_path__ + "static/media/weather-moon.c84a6684765aed3f9110a2e17f855725.svg";
export { ForwardRef as ReactComponent };